module.exports = __webpack_public_path__ + "static/rua@2x-dda540e5869cc8e488b11f5be4cbe9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/rua@2x.jpg
// module id = 934
// module chunks = 18116671869107 235176306749093